import { useLocation, useNavigate } from 'react-router-dom'
import { TRoutesTree } from 'types/routes'
import { Tabs } from 'antd'
import { flattenRoutes } from '@organisms/routesTree'
import { useRoutesData } from '@hooks/useRoutesData'


export const RouteTabs = ({ routesTree, centered = false, style = {} }: {
    routesTree: TRoutesTree
    centered?: boolean
    style?: React.CSSProperties
}) => {
    const routesData = useRoutesData(routesTree)

    const navigate = useNavigate()
    const location = useLocation()

    const flatRoutes = flattenRoutes(routesTree)
    const tabRoutes = flatRoutes.filter((route) => route?.custom?.isHasTab)
    
    const tabItems = tabRoutes.map((route) => ({
        label: route.title,
        key: route.path.replace(/^\//, ''),
    }))

    const handleTabChange = (key: string) => navigate(key, { relative: 'route' })

    const activeKey = tabItems.find(tab => tab.key && location.pathname.includes(tab.key))?.key || '';

    if(!!routesData.currentRoutes.find((route) => route?.custom?.isHideTabs)) {
        return null
    }

    return (
        <Tabs
            items={tabItems}
            activeKey={activeKey}
            onChange={handleTabChange}
            centered={centered}
            style={style}
        />
    )
}
